module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("I wish to express my gratitude to the following people who helped me with their comments, critiques, and discussions: Max Baker-Hytch, Phillip Cary, Helen de Cruz, Timo Nisula, Rich Park, Tim Pawl, Ryan Pemberton, Andrew Pinsent, Jeroen de Ridder, Johan de Smedt, Nathanael Smith, Joshua Thurow, Roger Trigg, Aku Visala, Joseph Wolyniak, and Hetty Zock. Special thanks are due to Simo Knuuttila and Risto Saarinen, who were in charge of the Academy of Finland’s Political Philosophy, Morality and Psychology Centre of Excellence, which enabled me to pursue this project. I also thank two anonymous reviewers for their comments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I have presented parts of this book in several academic settings. I am very grateful to the hosts and participants of the following gatherings: Ian Ramsey Centre Seminar at the University of Oxford; the conference of European Society of Philosophy of Religion; Williamson Conference at Austin Theological Seminary, Texas; and the research seminar at the Faculty of Philosophy, Umeå University, Sweden.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The work has been financially supported by the Faculty of Theology (University of Helsinki); the Academy of Finland; the Finnish Association of Non-fiction Writers; and Kellogg College, Oxford.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Parts of chapter 5.4 have been printed before in "), _c('i', [_vm._v("Religion in Public Life")]), _vm._v(", edited by Niek Brunsveld and Roger Trigg, Ars Disputandi Supplement Series 5 (Utrecht: Ars Disputandi, 2011). Reprinted by permission.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0